import { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const Reject: FC<IconProps> = ({ width = 18, height = 18, fill = '#D92020', className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM13 5.08078C13.2538 5.33462 13.2538 5.74618 13 6.00002L9.91926 9.00004L12.9192 12.0808C13.1731 12.3346 13.1731 12.7462 12.9192 13C12.6654 13.2538 12.2538 13.2538 12 13L9.00002 9.91927L6.00002 13C5.74618 13.2539 5.33462 13.2539 5.08078 13C4.82694 12.7462 4.82694 12.3346 5.08078 12.0808L8.08078 9.00004L5.08075 6.00002C4.82691 5.74618 4.82691 5.33462 5.08075 5.08078C5.33459 4.82694 5.74615 4.82694 5.99999 5.08078L9.00002 8.0808L12.0808 5.08078C12.3346 4.82694 12.7462 4.82694 13 5.08078Z"
        fill={fill}
      />
    </svg>
  );
};
